import styled from "styled-components";
import theme from "../../../../theme/theme";

interface IDatePickerCustom {
  $isError: boolean;
  $maxWidth?: string;
  $textAlign?: string;
}

export const DatePickerCustomContainer = styled.div<IDatePickerCustom>`
  width: 100%;
  text-align: ${props => props.$textAlign};
  margin: 0 0 15px 0;


  & div:nth-child(2) > div:first-of-type {
    height: 2.25rem;
    border-radius: 10px;
    font-size: 16px;
    line-height: 22px;
    padding: 8px 22px;
    background: white;
    color: ${theme.colors.grey1};
    border: ${props => props.$isError ? '2px solid #A41313' : `2px solid ${theme.colors.grey5}`};
    ${props => props.$maxWidth && `max-width: ${props.$maxWidth}`};
  }

  & fieldset {
    border: none;
  }

  & input {
    padding: 14px 0px;
  }
`
